import { Code, ConnectError } from '@connectrpc/connect';
/**
 * SAD-307: a PermissionDenied refusal must read as plain product copy — not
 * leak the Connect code or internal policy/bundle identifiers (e.g.
 * "area:registries", "growth_ops"). Every other failure keeps the server's
 * own explanation via rawMessage, so only the "[code]" prefix drops — a
 * validation message like "title is required" must still reach the user.
 *
 * `entity` is the user-facing noun (EntityDescriptor.key, e.g. "labor
 * category"); omit it where the caller has no entity in scope (EntityForm's
 * generic submit-error banner) and the copy falls back to "this change".
 */ export function entityErrorMessage(err, action = 'save', entity) {
    if (err instanceof ConnectError && err.code === Code.PermissionDenied) {
        const subject = action === 'delete' ? entity ? `delete this ${entity}` : 'delete this' : entity ? `edit this ${entity}` : 'make this change';
        const outcome = action === 'delete' ? 'nothing was deleted' : 'nothing was saved';
        return `You don't have permission to ${subject}. ` + `Ask an admin to grant your account access for this organization, then retry — ${outcome}.`;
    }
    const detail = err instanceof ConnectError ? err.rawMessage : err instanceof Error ? err.message : undefined;
    if (!entity) {
        return detail || 'Something went wrong.';
    }
    return detail ? `Failed to ${action} ${entity}: ${detail}` : `Failed to ${action} ${entity}`;
}
